import { useContext } from "react"
import { KeyRound } from "lucide-react"
import { ReactComponent as QRCODE } from "../../../../assets/QrCode.svg"
import { ReactComponent as FOLDER } from "../../../../assets/Folder.svg"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import BaseButton from "../../../../components/elements/BaseButton"

type ObjectDetailActionsType = {
    lvdoesnotexist: boolean
    obvdoesexist: boolean
    ranking?: number
}

const rankingClass = (ranking?: number) => {
    if (ranking === 1) return "radio-success"
    if (ranking === 2) return "radio-warning"
    if (ranking === 3) return "radio-error"
    return ""
}

export default function ObjectDetailActions(props: ObjectDetailActionsType) {
    const modalCon = useContext(ModalContext)
    return (
        <div className="flex flex-row flex-wrap items-center justify-end gap-4">
            <Authorized allOf={[P.objekte_read_write, P.buchhaltung_read]}>
                <BaseButton
                    label="QR-Code"
                    icon={<QRCODE className="w-4 h-4" />}
                    func={() => modalCon?.trigger(8)}
                    type="button"
                    
                />
                <BaseButton
                    label="Schlüssel"
                    icon={<KeyRound className="w-4 h-4" />}
                    func={() => modalCon?.trigger(10)}
                    type="button"
                    
                />
                <BaseButton
                    label="Dokumente"
                    icon={<FOLDER className="w-4 h-4" />}
                    func={() => modalCon?.trigger(9)}
                    type="button"
                    
                />
                <Authorized allOf={[P.termine_management]}>
                    <BaseButton label="LV" func={() => modalCon?.trigger(11)} type="button"  />
                </Authorized>
                <BaseButton label="Vertrags-LV" func={() => modalCon?.trigger(5)} type="button"  classProps="hidden lg:flex" />
                {props.obvdoesexist && (
                    <BaseButton
                        label="OBV"
                        func={() => modalCon?.trigger(7)}
                        type="button"
                        
                        classProps="hidden lg:flex"
                        disabled={props.lvdoesnotexist}
                    />
                )}
            </Authorized>
            {props.ranking ? (
                <span className="shrink-0" title="Bewertung">
                    <input type="radio" className={`radio ${rankingClass(props.ranking)}`} checked readOnly aria-label="Bewertung" />
                </span>
            ) : null}
        </div>
    )
}
